<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>Hr系统</el-breadcrumb-item>
      </el-breadcrumb>
    </template>

    <el-tabs type="border-card" v-model="tabName" @tab-change="tabChange">
      <el-tab-pane name="monthDaily">
        <template #label>
          <span> 月度报表 </span>
        </template>

        <el-form :model="querys" ref="querys" label-width="70px" class="search-form">
          <el-row>
            <el-form-item label="月份" label-width="90px">
              <el-col>
                <el-date-picker v-model="monthValue" type="month" placeholder="选择查阅的月份" @change="dailyFetch()" />
              </el-col>
            </el-form-item>

            <el-form-item label="" label-width="20px">
              <el-button type="primary" icon="search" @click="dailyFetch()">
                搜索
              </el-button>
            </el-form-item>
          </el-row>
        </el-form>

        <el-table class="table" :data="dailyData" border size="small" style="width: 100%" height="70vh">
          <el-table-column fixed type="index" label="序号" align="center" width="50"> </el-table-column>
          <el-table-column fixed prop="姓名" label="姓名" sortable width="85"> </el-table-column>
          <!-- <el-table-column label="备注" sortable width="130">
            <template #default="{ row }">
              <span v-if="row.旷工次数">旷工次数:{{ row.旷工次数 }}；</span>
              <span v-if="row.迟到次数">迟到次数:{{ row.迟到次数 }}；</span>
              <span v-if="row.早退次数">迟到次数:{{ row.早退次数 }}；</span>
              <span v-if="row.未打卡次数">未打卡数:{{ row.未打卡次数 }}；</span>
            </template>
          </el-table-column> -->
          <el-table-column v-for="day in dynamicDays" :key="day" :prop="day" :label="day" align="center" width="100">
            <template #default="{ row }">
              <div v-if="row[day]">
                <template v-for="(item, idx) in row[day].split('|')" :key="idx">
                  <div v-if="item">
                    <span>{{ item.split('/')[0] }} </span> <!--时间-->
                    <span :style="{
                      color:
                        item.split('/')[1] === 'Normal' ? '#67c23a' // 正常绿色
                          : item.split('/')[1] === 'Absenteeism' ? '#f56c6c' // 旷工红色
                            : item.split('/')[1] === 'Early' ? '#e6a23c' // 早退橙色
                              : item.split('/')[1] === 'Late' ? '#e6a23c' // 迟到橙色
                                : item.split('/')[1] === 'SeriousLate' ? '#f56c6c' // 严重迟到红色
                                  : item.split('/')[1] === 'NotSigned' ? '#909399' // 未打卡灰色
                                    : '#606266' // 其他灰色
                    }">
                      {{
                        item.split('/')[1] === 'Normal' ? '正常'
                          : item.split('/')[1] === 'Absenteeism' ? '旷工'
                            : item.split('/')[1] === 'Early' ? '早退'
                              : item.split('/')[1] === 'Late' ? '迟到'
                                : item.split('/')[1] === 'SeriousLate' ? '严重迟到'
                                  : item.split('/')[1] === 'NotSigned' ? '未打卡'
                                    : item.split('/')[1]
                      }}
                    </span>
                  </div>
                </template>
              </div>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column fixed prop="旷工次数" label="旷工数" sortable width="80" align="center"> </el-table-column>
          <el-table-column fixed prop="迟到次数" label="迟到数" sortable width="80" align="center"> </el-table-column>
          <el-table-column fixed prop="早退次数" label="早退数" sortable width="80" align="center"> </el-table-column>
        </el-table>

      </el-tab-pane>

      <el-tab-pane name="signData">
        <template #label>
          <span> 打卡记录 </span>
        </template>

        <el-form :model="querys" ref="querys" label-width="70px" class="search-form">
          <el-row>
            <el-form-item label="关键词" prop="keyword">
              <el-col>
                <el-input v-model="querys.keyword" prefix-icon="Search"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item label="打卡时间" label-width="90px">
              <el-col>
                <el-date-picker v-model="dateRange" type="daterange" start-placeholder="开始时间" end-placeholder="结束时间"
                  unlink-panels :shortcuts="$util.getShortCuts()" @change="fetchs" style="max-width:210px;">
                </el-date-picker>
              </el-col>
            </el-form-item>

            <el-form-item label="" label-width="20px">
              <el-button type="primary" icon="search" @click="fetchs()">
                搜索
              </el-button>
            </el-form-item>
          </el-row>
        </el-form>

        <basic-table class="table"  :query="querys" @handler="fetchs" :currHandler="currHandler">
          <template v-slot:sourceType="scope">
            <span style="color:#79bbff" v-if="scope.row.sourceType == 'ATM'">考勤机打卡</span>
            <span style="color:#79bbff" v-else-if="scope.row.sourceType == 'DING_ATM'">钉钉考勤机</span>
            <span style="color:#79bbff" v-else-if="scope.row.sourceType == 'USER'">用户打卡</span>
            <span style="color:#79bbff" v-else-if="scope.row.sourceType == 'BOSS'">老板改签</span>
            <span style="color:#79bbff" v-else-if="scope.row.sourceType == 'APPROVE'">审批系统</span>
            <span style="color:#79bbff" v-else-if="scope.row.sourceType == 'SYSTEM'">考勤系统</span>
            <span style="color:#79bbff" v-else-if="scope.row.sourceType == 'AUTO_CHECK'">自动打卡</span>
            <span v-else>未知</span>
          </template>
          <template v-slot:timeResult="scope">
            <span style="color:#67c23a" v-if="scope.row.timeResult == 'Normal'">正常</span>
            <span style="color:#f56c6c" v-else-if="scope.row.timeResult == 'Early'">早退</span>
            <span style="color:#e6a23c" v-else-if="scope.row.timeResult == 'Late'">迟到</span>
            <span style="color:#f56c6c" v-else-if="scope.row.timeResult == 'SeriousLate'">严重迟到</span>
            <span style="color:#f56c6c" v-else-if="scope.row.timeResult == 'Absenteeism'">旷工迟到</span>
            <span style="color:#f56c6c" v-else-if="scope.row.timeResult == 'NotSigned'">未打卡</span>
            <span v-else>未知</span>
          </template>
          <template v-slot:locationResult="scope">
            <span style="color:#67c23a" v-if="scope.row.locationResult == 'Normal'">范围内</span>
            <span style="color:#f56c6c" v-else-if="scope.row.locationResult == 'Outside'">范围外</span>
            <span style="color:#f56c6c" v-else-if="scope.row.timeResult == 'NotSigned'">未打卡</span>
            <span v-else>未知</span>
          </template>
          <template v-slot:checkType="scope">
            <span style="color:#67c23a" v-if="scope.row.checkType == 'OnDuty'">上班</span>
            <span style="color:#79bbff" v-else-if="scope.row.checkType == 'OffDuty'">下班</span>
            <span v-else>未知</span>
          </template>

          <!-- <template v-slot:toolbar="scope">
          <el-button @click="openPage(scope.row)" link size="small">
            <span v-if="scope.row.status == 0">[编辑]</span>
            <span v-else>[查看]</span>
          </el-button>
        </template> -->
        </basic-table>
      </el-tab-pane>
    </el-tabs>

  </el-card>
</template>

<script>
import { fetchSignLog } from "@/api/hrdata";
import StaticDialog from "@/components/static-dialog.vue";
import BasicTable from "@/components/basic-table.vue";
export default {
  name: "signlog",
  components: { StaticDialog, BasicTable },
  data() {
    return {
      tabName: "monthDaily", //当前tab名称
      querys: {
        keyword: "",
        columns: [
          { type: "index", label: "序号" },
          { prop: "realName", label: "员工姓名", sortable: true, width: "100", showOverflowTooltip: true },
          { type: "template", prop: "sourceType", label: "数据来源", width: "130" },

          { type: "template", prop: "checkType", label: "考勤类型", width: "80" },
          { prop: "baseCheckTime", label: "基准时间", width: "150", sortable: true, showOverflowTooltip: true },
          { prop: "userCheckTime", label: "打卡时间", width: "150", sortable: true, showOverflowTooltip: true },

          { type: "template", prop: "locationResult", label: "位置结果", width: "100", sortable: true },
          { type: "template", prop: "timeResult", label: "打卡结果", width: "100", sortable: true },
          { prop: "workDate", label: "工作日", width: "150", sortable: true, showOverflowTooltip: true },

          { prop: "createDate", label: "同步时间", width: "150", sortable: true, },
          { prop: "createUserName", label: "同步人", sortable: true, searchable: true, width: "100", },
          //{ type: "toolbar", label: "操作" },
        ],
      },
      pager: {
        sidx: "baseCheckTime", //默认的排序字段
        sord: "desc",
      },
      currRow: null,
      dateRange: [],
      monthValue: null, // 月份选择器的值
      dailyData: [], // 月度报表数据
    };
  },
  mounted() {
    this.monthValue = this.$util.fmtDate(new Date(), "yyyy-MM");
    this.tabChange();
  },
  methods: {
    fetchs() {
      //移除多余的参数
      //let { data, records, total, ...query } = { ...this.pager, ...params };
      let { data, records, total, ...search } = {
        ...this.pager,
        ...this.querys,
      };
      this.querys.filters = [];
      // search.filters = [];
      // if (this.querys.keyword)
      //   search.filters.push({
      //     name: "account",
      //     value: "%" + this.querys.keyword + "%",
      //     operate: "like", 5
      //   });
      if (this.dateRange && this.dateRange[0])
        this.querys.filters.push({
          name: "userCheckTime",
          value: this.$util.fmtDate(this.dateRange[0], "yyyy-MM-dd"),
          operate: 2,
        });
      if (this.dateRange && this.dateRange[1])
        this.querys.filters.push({
          name: "userCheckTime",
          value: this.$util.fmtDate(this.dateRange[1], "yyyy-MM-dd") + " 23:59:59",
          operate: 4,
        });

      fetchSignLog(search).then((res) => {
        this.querys = { ...this.querys, ...res.data, columns: [...this.querys.columns] };
        this.pager = { ...this.pager, ...res.data };
      });
    },
    currHandler(row) {
      this.currRow = row;
    },
    pageHandler(page) {
      this.pager.page = page;
      this.fetchs();
    },
    sizeHandler(rows) {
      this.pager.rows = rows;
      this.fetchs();
    },
    sortHandler(order) {
      this.pager.sidx = order.prop;
      this.pager.sord = order.order;
      this.fetchs();
    },
    openPage(row) {
      this.$router.push({ path: row.formUrl, query: { id: row.id } });
    },
    tabChange() {
      if (this.tabName == 'monthDaily') {
        this.dailyFetch();
      }
      else if (this.tabName == 'signData') {
        this.fetchs();
      }
    },
    dailyFetch() {
      this.monthValue = this.$util.fmtDate(this.monthValue, "yyyy-MM");
      this.$kaung.fetch({
        url: '/HrSignLog/SignMonthDaily?year=' + this.monthValue.split("-")[0] + '&month=' + this.monthValue.split("-")[1],
        method: 'post'
      }).then((res) => {
        this.dailyData = res.data;
      });
    }
  },
  computed: {
    dynamicDays() {
      if (!this.dailyData.length) return [];
      // 过滤出所有“xx日”字段
      return Object.keys(this.dailyData[0]).filter(key => /\d+日$/.test(key));
    }
  }
};
</script>


